import ReactGA from 'react-ga';
const GA_TAG_ID = 'G-XL3NKBZ7FW';

ReactGA.initialize(GA_TAG_ID);

export { ReactGA, GA_TAG_ID };
